import { MediaTypes } from "../constants";
import { CenterContainer, SizedText } from "../styles/styles";
import { useTranslation } from "@coworker/locales";

interface EmptymediaPlaceholderProps {
  mediaType: MediaTypes;
}
export const EmptyMediaPlaceholder = ({
  mediaType,
}: EmptymediaPlaceholderProps) => {
  const { t } = useTranslation();

  return (
    <CenterContainer
      $centerText={true}
      style={{ margin: "48px 16px", gap: "12px" }}
    >
      <SizedText $fontSize={24} $bold={true}>
        {mediaType === MediaTypes.HOME
          ? t("homeNoRoomsAddedString")
          : t("mediaNoArticlesAddedString")}
      </SizedText>
    </CenterContainer>
  );
};
